var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "", "text-xs-center": "" } },
                    [
                      _c("StepTitle", [_vm._v("Filtro de Actividad")]),
                      _c("v-divider"),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm6: "",
                                md6: "",
                                "offset-xs10": "",
                                "align-end": ""
                              }
                            },
                            [
                              _c("AgregarButton", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.modoVer,
                                    expression: "!modoVer"
                                  }
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.handleAgregarClick()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  !_vm.modoVer
                                    ? _c("MantenedorGrid", {
                                        attrs: {
                                          "grid-options": _vm.gridOptions
                                        }
                                      })
                                    : _c("MantenedorGridVerDetalle", {
                                        attrs: {
                                          "grid-options":
                                            _vm.gridOptionsVerDetalle
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("CrearScriptModal", {
        attrs: {
          show: _vm.muestraModalScript,
          titulo: "Agregar Filtro de Actividad",
          modoEditar: _vm.modoEditarScript,
          scriptSeleccionado: _vm.scriptSeleccionado
        },
        on: {
          cerrar: _vm.handleCierreModal,
          crear: _vm.handleModalScriptCrear,
          editar: _vm.handleModalScriptEditar
        }
      }),
      _c("ValidarFiltroActividadModal", {
        attrs: { show: _vm.muestraModalValidar, script: _vm.scriptValidar },
        on: { cerrar: _vm.handleCierreModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }